import Close from "@mui/icons-material/Close"
import { useContext, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { changes } from "src/components/utils/fields"
import {
  LoadingContext,
  M_Button,
  M_CheckBox,
  M_Fieldset,
  M_FormFavorites,
  M_SimpleTable,
} from "src/M_Components"
import { QuoteFormField } from "./QuoteFormField"

export const QuoteEquipment = ({ dataState, setDataState }) => {
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()

  const [isMultiEditable, setIsMultiEditable] = useState(!dataState.isMultiEdit)

  const hasEquipments = (dataState?.Equipments?.length || 0) > 0

  const formFields = [
    { display: t("Quantity"), code: "quantity", type: "number" },
    {
      display: t("EquipmentType"),
      required: false,
      code: "equipmentType",
      type: "foreignKey",
      entity: "EquipmentType",
      filterField: "EquipmentTypeCode",
      labelFields: ["EquipmentTypeLenght", "EquipmentTypeCode"],
      fields: [
        { key: "EquipmentTypeLenght", value: "equipmentTypeLenght" },
        { key: "EquipmentTypeCode", value: "equipmentTypeCode" },
        { key: "Id", value: "equipmentTypeId" },
      ],
      favoritesFieldName: t("EquipmentType"),
      favoritesGroupName: "Equipment",
      favoritesVarKey: "equipmentType",
      favoritesIdKey: "equipmentTypeId",
    },
  ]

  const equipmentVarNameDict = useMemo(() => new Map([
    ['equipmentType', dataState.equipmentType || ''],
    ['equipmentTypeId', dataState.equipmentTypeId || ''],
  ]), [dataState.equipmentType, dataState.equipmentTypeId])

  const onChangeEquipment = (row, fields, obj) => {
    if (obj) {
      changes("equipmentTypeLenght", obj["EquipmentTypeLenght"], setDataState)
      changes("equipmentTypeCode", obj["EquipmentTypeCode"], setDataState)
      changes("equipmentTypeId", obj["Id"], setDataState)
      changes(
        "equipmentType",
        `${obj["EquipmentTypeLenght"]}${obj["EquipmentTypeCode"]}`,
        setDataState,
      )
    }
  }

  const addEquipment = () => {
    if (!dataState.equipmentTypeId) {
      ctx.toastMessages('error', '', t('EquipmentType') + ' ' + t('IsRequired'))
      return
    }
    let counter = dataState?.EquipmentCounter || 1
    let newObj = {}
    let throwError = false

    formFields.forEach((obj) => {
      if (obj?.required && !dataState?.[obj.code]) {
        ctx.toastMessages("error", [obj.display] + " field is required", "")
        throwError = true
      }
    })
    if (throwError) {
      return
    }

    formFields.forEach((obj) => {
      if (
        obj.code === "quantity" &&
        (!dataState?.[obj.code] || dataState?.[obj.code] < 1)
      ) {
        newObj[obj.code] = 1
      } else {
        newObj[obj.code] = dataState?.[obj.code] || ""
      }
      changes(obj.code, "", setDataState)
      if (obj.labelFields) {
        obj.fields.forEach((extra) => {
          newObj[extra.value] = dataState[extra.value] || ""
          changes(extra.value, "", setDataState)
        })
      }
    })

    const newEquipment = dataState?.Equipments || []
    newObj.Id = counter
    changes("EquipmentCounter", counter + 1, setDataState)
    newEquipment.push(newObj)
    changes("Equipments", newEquipment, setDataState)
  }

  const deleteEquipment = (row) => {
    const newEquipments = dataState?.Equipments.filter(
      (equip) => equip.Id !== row.Id,
    )
    changes("Equipments", newEquipments, setDataState)
  }

  return (
    <M_FormFavorites
      entityName="Quotes"
      pageUrl="Quote"
      varNameDict={equipmentVarNameDict}
      setVarNameDict={() => {}}
      onFavoriteLoad={(loadedData) => {
        setDataState(prev => ({ ...prev, ...loadedData }))
      }}
      onAfterApply={() => {}}
    >
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <i
              className="pi pi-box"
              style={{ marginRight: "10px", fontSize: "30px" }}
            ></i>{" "}
            {t("Equipment")}
            {dataState.isMultiEdit && <M_CheckBox checked={isMultiEditable} onChange={(e) => {setIsMultiEditable(e.target.checked)}} />}
          </div>
        }
        elements={
          <div>
            <div
              style={{
                display: "grid",
                justifyContent: "space-evenly",
              }}
            >
              {formFields.map((field, index) => {
                if (field.code === "equipmentType") {
                  return <QuoteFormField fields={{...field, required: field.required && !hasEquipments}} index={index} data={dataState} setData={setDataState} hideLabels={null} returnFunc={onChangeEquipment} disabled={!isMultiEditable} />
                }
                return <QuoteFormField fields={field} index={index} data={dataState} setData={setDataState} disabled={!isMultiEditable} />
              })}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <M_Button
                  bold
                  normal
                  hoverEffect
                  label={t("Add")}
                  icon={<img src='/icons/svgsDaNet/plus-square.svg' alt={t("Add")} style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)' }} className='iconCreateBooking' />}
                  borderColor={'var(--color-grey)'}
                  onClick={() => addEquipment()}
                  disable={!isMultiEditable}
                />
              </div>
            </div>
            <div style={{ marginBottom: "20px" }}></div>
            <M_SimpleTable
              rows={(dataState["Equipments"] && dataState["Equipments"]) || []}
              columns={[
                ...formFields
                  .map((obj) => {
                    return { header: obj.display, field: obj.code }
                  })
                  .filter(
                    (obj) => obj.type !== "whiteSpace" || obj.type !== "",
                  ),
                {
                  header: "",
                  body: (row) => (
                    <M_Button
                      none
                      icon={<Close style={{ color: "var(--color-red)" }} />}
                      onClick={() => deleteEquipment(row)}
                    />
                  ),
                },
              ]}
            />
          </div>
        }
      />
    </M_FormFavorites>
  )
}
